import React from 'react'
import { IconLink } from './SocialButtons.styled'

interface SocialLinkProps {
  url?: string
  title: string
  children: React.ReactNode
}

const SocialLink = ({ url, title, children }: SocialLinkProps) => {
  if (!url) {
    return null
  }

  return (
    <IconLink target="_blank" rel="noreferrer" href={url} title={title}>
      {children}
    </IconLink>
  )
}

export default SocialLink
